import React from 'react'

export default class Shop extends React.Component {
    render() {
        return <p>Hello World</p>
    }
}
